<div
  class="reset-icon-cell-template"
  [tooltip]="tooltip()"
  [tooltipEnabled]="tooltip() !== undefined"
>
  <button
    type="button"
    andButton
    color="ghost-secondary"
    size="small"
    [disabled]="tooltip() !== undefined"
    [isLoading]="isLoading()"
    (click)="onClick()"
  >
    <anduin-icon name="refresh-ccw" class="me-1" />
    Resend
  </button>
</div>
